module.exports = __webpack_public_path__ + "static/media/or-zh-hk.e9c84877.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/or-zh-hk.svg
// module id = 1268
// module chunks = 0